import * as moment from 'moment';

class StylingService {
    public selectAgeStyle(
        creationDate: moment.Moment,
        intervalStyleBindings: IIntervalStyleBinding[],
        defaultStyle = ''
    ): string {
        if (!creationDate || !intervalStyleBindings) {
            return defaultStyle;
        }
        // sort reversed
        intervalStyleBindings.sort(
            (first, second) => second.timeInterval.asMilliseconds() - first.timeInterval.asMilliseconds()
        );
        // return selected class
        const today = moment().startOf('day');
        return (
            intervalStyleBindings.find(intervalStyle =>
                creationDate.isBefore(today.clone().subtract(intervalStyle.timeInterval))
            ) || intervalStyleBindings[intervalStyleBindings.length - 1]
        ).styleClass;
    }
}

export const stylingService = new StylingService();

export interface IIntervalStyleBinding {
    timeInterval: moment.Duration;
    styleClass: string;
}
